import { connect } from 'react-redux';
import ButtonBadge from './buttonbadge';
import moment from 'moment';
import { filterOrders } from "../../reselect/order.selector";

const mapStateToProps = (state, ownProps) => {
    const { mode } = ownProps;

    return {
        count: calculateFilterButtonBadgeNumber(state, mode),
    };
};

const mapDispatchToProps = dispatch => ({
});

const calculateFilterButtonBadgeNumber = (state, mode) => {
    return filterOrders(
        moment().add(-30, 'minute').toDate(),
        moment().add(mode.value, 'minute').toDate(),
        mode.id,
        state.orders.orders,
        state.orders.orderhistory,
        state.orders.routeplanning,
        state.orders.routestops
    ).length;
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonBadge);
